module.exports = __webpack_public_path__ + "static/media/airlyze_logo.10b0eb66.png";